import React from "react";
import { getRecoil } from "recoil-nexus";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

import organizationIdSelector from "../atoms/organizationIdSelector";
import { GroupType } from "../data/MessageData";
import { consola } from "consola";

export type useMessageGroupDataProps = {
  users: string[];
  order: string;
  groupType?: typeof GroupType | undefined;
  direction: "asc" | "desc";
  onSnapshot: (snapshot: any) => void;
  /** When true the hook skips opening a Firestore listener entirely. */
  disabled?: boolean;
};

const useMessageGroupData = ({
  users,
  order,
  groupType,
  direction,
  onSnapshot,
  disabled = false,
}: useMessageGroupDataProps) => {
  const organizationId = getRecoil(organizationIdSelector);

  React.useEffect(() => {
    // Skip the subscription when this tab is not active
    if (disabled) return;

    let groupRef;

    if ((groupType as unknown as string) === GroupType.single) {
      groupRef = firebase
        .firestore()
        .collection("organizations")
        .doc(organizationId)
        .collection("messageGroups")
        .where("users", "array-contains-any", users);
    } else {
      groupRef = firebase
        .firestore()
        .collection("organizations")
        .doc(organizationId)
        .collection("messageGroups");
    }

    if (groupType) {
      groupRef = groupRef.where("type", "==", groupType);
    }

    if (order) {
      groupRef = groupRef.orderBy(order, direction);
    }

    const subscription = groupRef.onSnapshot((snapshot) => {
      consola.debug("++++++ SNAPSHOT -> useMessageGroupData", groupType);
      if (onSnapshot && snapshot) {
        const groupDataArray = snapshot.docs.map((d: any) => {
          return {
            ...d.data(),
            ref: d.ref,
          };
        });
        onSnapshot(
          groupDataArray.filter((d) => {
            if ("isArchived" in d) {
              return !d.isArchived || d.isArchived === false;
            }
            return true;
          }),
        );
      }
    });

    return () => {
      subscription();
    };
  }, [organizationId, onSnapshot, users, order, direction, groupType, disabled]);

  return true;
};

export default useMessageGroupData;
